// 新闻页面顶部筛选tab
export let orderTabLabels = [
  {
    label: '状态',
    type: 'select',
    value: 'status',
    clearable: true,
    options: [
      {
        label: '待处理',
        value: 'WAITFOR_HANDING'
      },
      {
        label: '已导出',
        value: 'EXPORTED'
      }
    ]
  }
]
// 新闻列表表头
export let tableLabels = [
  {
    label: '用户',
    value: 'createName'
  },
  {
    label: '姓名',
    value: 'customerName'
  },
  {
    label: '商品',
    value: 'goodName'
  },
  {
    label: '产品',
    value: 'subscribeValue'
  },
  {
    label: '手机',
    value: 'customerPhone'
  },
  {
    label: '希望联系时间',
    value: 'subscribeDate'
  },
  {
    label: '预约提交时间',
    value: 'createdDate'
  }
]
// 预约时间
export let subscribeDate = [
  {
    label: '8:00-10:00',
    value: '8:00-10:00'
  },
  {
    label: '10:00-12:00',
    value: '10:00-12:00'
  },
  {
    label: '12:00-14:00',
    value: '12:00-14:00'
  },
  {
    label: '14:00-16:00',
    value: '14:00-16:00'
  },
  {
    label: '16:00-18:00',
    value: '16:00-18:00'
  }
]

export let historyList = [
  {
    label: '导出时间',
    value: 'createdDate'
  },
  {
    label: '导出条数',
    value: 'count'
  }
]
